// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, boolean, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isAppGroupResult = objectOf({
  apps: arrayOf(
    objectOf({
      id: string,
      name: string,
      imageUrl: string,
      type: string,
      uninstallTrackingSupport: boolean,
      geofenceSupport: boolean,
      pushProviderType: string,
    })
  ),
  sdkInfo: objectOf({
    android: objectOf({
      latestSeenVersion: string,
      earliestLiveVersion: string,
    }),
    androidChina: objectOf({
      latestSeenVersion: string,
      earliestLiveVersion: string,
    }),
    ios: objectOf({
      latestSeenVersion: string,
      earliestLiveVersion: string,
    }),
    kindle: objectOf({
      latestSeenVersion: string,
      earliestLiveVersion: string,
    }),
    web: objectOf({
      latestSeenVersion: string,
      earliestLiveVersion: string,
    }),
    roku: objectOf({
      latestSeenVersion: string,
      earliestLiveVersion: string,
    }),
  }),
  id: string,
  api_id: string,
  name: string,
  imageUrl: string,
  hasSubscription: boolean,
  maxAnalyticsSegments: number,
  facebookAppCredentials: objectOf({
    hasValidAccessToken: boolean,
  }),
  languages: arrayOf(
    objectOf({
      languageCode: string,
      displayLanguage: string,
    })
  ),
  createdAt: number,
  anyAppsWithUninstallTracking: boolean,
  maxFileUploadSize: nullOrUndefined,
  contentCardMaxSize: number,
  contentBlockMaxSize: number,
  smsTimeRateLimit: number,
  enableCampaignApprovals: boolean,
  enableCanvasApprovals: boolean,
});
